import { Component, Input, OnInit } from '@angular/core';
import { Client } from '../../../core/models/clients.model';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { AbstractControl, FormControl, UntypedFormControl } from '@angular/forms';
import { ClientService } from '../../../core/services/client.service';

@Component({
  selector: 'app-form-field-client-select',
  templateUrl: './form-field-client-select.component.html',
  styleUrls: [ './form-field-client-select.component.scss' ]
})
export class FormFieldClientSelectComponent implements OnInit {

  @Input() control: FormControl | AbstractControl | UntypedFormControl;
  @Input() checkTutor: boolean = false;
  @Input() isTutor: boolean = null;

  public filteredOptions$: Observable<Client[]>;
  public clients: Client[] = [];

  private filteredOptionsSubject = new BehaviorSubject<Client[]>([]);
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private client$: ClientService
  ) {
  }

  asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;

  ngOnInit(): void {
    this.filteredOptions$ = this.filteredOptionsSubject.asObservable();
    this.client$.clients$.pipe(takeUntil(this._unsubscribeAll)).subscribe(clients => {
      this.clients = clients
        .filter(f => {
          if (this.checkTutor) {
            return f.isTutor === this.isTutor;
          } else {
            return true;
          }
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getAutoCompleteDisplayValue(option: Client): string | undefined {
    return option ? (option.name + ' ' + option.lastname1 + ' ' + option.lastname2) : undefined;
  }

  onAutocompleteKeyUp(value: string, options: Client[]): void {
    const lowerSearchText = value?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    this.filteredOptionsSubject.next(
      !lowerSearchText
        ? options
        : options.filter(r => (r.name + ' ' + r.lastname1 + ' ' + r.lastname2)
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(lowerSearchText)));
  }
}
